import { RootState } from "@storeEnv/appStore";

export const selectModalStack = (state: RootState) => state.modalStack.stack;

export const selectIsTopModal = (id: string) => (state: RootState) => {
  const stack = state.modalStack.stack;
  return stack[stack.length - 1] === id;
};
